module.exports = __webpack_public_path__ + "static/media/lbhospital.ee41a65c.png";